import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconMoneyBagLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.515 20.5c-1.4 0-2.587-.486-3.558-1.457-.971-.97-1.457-2.158-1.457-3.562 0-.586.1-1.156.301-1.711.2-.556.488-1.06.862-1.51l3.531-4.246L6.6 4.806a.85.85 0 0 1 .028-.879c.172-.285.431-.427.776-.427h9.192c.345 0 .604.142.776.427a.85.85 0 0 1 .028.879l-1.594 3.208 3.53 4.246c.375.45.662.954.863 1.51.2.555.301 1.125.301 1.711 0 1.404-.488 2.591-1.463 3.562-.975.971-2.16 1.457-3.552 1.457h-6.97Zm3.483-4.76c-.497 0-.923-.177-1.276-.531a1.745 1.745 0 0 1-.53-1.278c0-.498.177-.923.532-1.276.354-.353.78-.53 1.278-.53.497 0 .923.177 1.276.531.353.355.53.78.53 1.278s-.177.923-.532 1.277c-.354.353-.78.53-1.278.53Zm-2.43-8.365h4.874L15.625 5h-7.25l1.192 2.375ZM8.514 19h6.97c.982 0 1.813-.342 2.494-1.026.68-.684 1.021-1.515 1.021-2.492 0-.411-.07-.81-.212-1.198a3.473 3.473 0 0 0-.607-1.051l-3.627-4.358H9.47l-3.64 4.342a3.526 3.526 0 0 0-.612 1.06A3.47 3.47 0 0 0 5 15.484c0 .976.342 1.806 1.026 2.49C6.71 18.658 7.54 19 8.516 19Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconMoneyBagLine;
